// extracted by mini-css-extract-plugin
module.exports = {"row":"OdpdFooter_row__q8UJW","button":"OdpdFooter_button__6V1lZ","button-ltr":"OdpdFooter_button-ltr__2GpLS"};